import { IconTag } from "@/molecules/IconTag"
import { ShowMore } from "@/molecules/ShowMore"

import styles from "./WorkflowTypeCell.module.scss"
import { WORKFLOW_TYPE_ICONS } from "./WorkflowTypeIcons"

import type { WorkflowTypeAi } from "@/api/useInventory.types"
import type { TFunction } from "@/hooks/useTranslation"

// How a workflow runs its steps, with what that means as a tooltip. A workflow whose code does not
// say shows no badge.
export const WorkflowTypeCell = (props: {
  type?: WorkflowTypeAi | null
  t: TFunction
}) => {
  const { type, t } = props

  if (!type) return null

  const Icon = WORKFLOW_TYPE_ICONS[type]

  // A type the API sends that this UI does not know shows no badge either
  if (!Icon) return null

  // The same hover explanation as the scan history results, from the shared ShowMore
  // One element: the badge's label and its hidden explanation are a single item in a row
  return (
    <span>
      <ShowMore
        id={`${type}-workflow-type`}
        // The explanation is read by the popup, not laid out: it must not widen the badge
        classes={{ template: styles.template }}
        label={
          <ShowMore.Label.Component>
            <IconTag
              icon={<Icon />}
              text={t(`inventory.ai.workflows.types.${type}`)}
            />
          </ShowMore.Label.Component>
        }
      >
        <ShowMore.Tooltip
          items={[t(`inventory.ai.workflows.typeTooltips.${type}`)]}
        />
      </ShowMore>
    </span>
  )
}
